import { Constant } from "app/shared/constant/constant";
import { ACCOUNT } from "app/shared/services/services-model.type";
import images from "app/shared/styles/images";
import { formatDateTime } from "app/shared/util/common";
import { ConvertCurrencyToVietnamese, formatCurrency } from "app/shared/util/format-currency";
import { DetailData } from "../detail-transaction";

export const reportTransferBackgroundHTMLString = (dataDetail: DetailData, accountInfo: ACCOUNT, type: string) => {
  const convertCurrencyToVietnamese = new ConvertCurrencyToVietnamese();
  let branchName: string = accountInfo?.BRANCH_CODE + " - " + accountInfo?.BRANCH_NAME;
  let transRef: string = dataDetail?.TRANSREF || "";
  let transferDate: string = formatDateTime(dataDetail?.DATETIME, "YYMMDDHHmm", "DD/MM/YYYY HH:mm") || "";
  let title: string = type === Constant.CREDIT ? "GIẤY BÁO CÓ" : "GIẤY BÁO NỢ";
  let textNote: string =
    type === Constant.CREDIT
      ? "Ngân hàng chúng tôi xin trân trọng thông báo đã ghi Có vào tài khoản của Quý khách với nội dung như sau:"
      : "Ngân hàng chúng tôi xin trân trọng thông báo đã ghi Nợ vào tài khoản của Quý khách với nội dung như sau:";
  let userName: string = accountInfo?.ACCOUNTNAME || "";
  let debitInfo = {
    accountNo: dataDetail?.DEBITACCNO || "",
    accountName: dataDetail?.DEBITACCNAME || "",
    bankName: type === Constant.DEBIT ? "PVCOMBANK - NH TMCP Đại Chúng Việt Nam" : dataDetail?.DEBITBANKNAME,
  };
  let creditInfo = {
    accountNo: dataDetail?.CREDITACCNO || "",
    accountName: dataDetail?.CREDITACCNAME || "",
    bankName: type === Constant.CREDIT ? "PVCOMBANK - NH TMCP Đại Chúng Việt Nam" : dataDetail?.CREDITBANKNAME || "",
  };
  let currencyText = formatCurrency(dataDetail?.AMOUNT);
  if (dataDetail?.AMOUNT && dataDetail?.AMOUNT.length > 0 && Number.isInteger(Number(dataDetail?.AMOUNT))) {
    currencyText = convertCurrencyToVietnamese.convert(Number(dataDetail?.AMOUNT));
  }

  let transferInfo = {
    transAmount: formatCurrency(dataDetail?.AMOUNT),
    formatAmount: currencyText,
    transFee: dataDetail?.CURRENCY_TOTALCHARGEAMT || "",
    content: dataDetail?.FTNARRATIVE || "",
  };
  // Create number formatter.
  const htmlString = `<!DOCTYPE html>
  <html translate="no" lang="vi">
      <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <meta name="googlebot" content="notranslate" />
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
          <style>
              @page WordSection1 {
                  size: A5;
                  margin: 54.0pt 36.0pt 36.0pt 36.0pt;
              }

              div.WordSection1 {
                  page: WordSection1;
              }

              body {
                  font-family: "Montserrat", serif;
                  font-size: small;
              }

              .font-text {
                font-family: "Montserrat", serif;
              }
              
              .div-border {
              	  border-style: solid;
                  border-width: 2px;
                  border-color: #000;
                  padding: 5px
              }

              .div-content {
                  text-align: left; 
              }
              
              .div-title {
                display:flex;
                flex:1;
                flex-direction:row;
                justify-content: space-between;
              }
              
              .title {
                flex:1;
                width: 100%;
                margin-top: 5px;
              }

              .left-title {
                  float: center;
                  min-width: 50%;
                  font-family: "Montserrat", serif;
                  font-weight: 600;
                  text-align: center;              
              }

              .right-title {
                  float: right;
                  min-width: 50%;
                  font-family: "Montserrat", serif;
                  font-weight: 600;
                  text-align: center;
              }

              .content-text {
                  font-family: "Montserrat", serif;
                  font-size: small;
              }

              .bold-text {
                  font-family: "Montserrat", serif;
                  font-weight: bold;
              }

              .center-title {
                  font-family: "Montserrat", serif;
                  font-weight: 700;
                  font-size: 18px;
                  padding: 4px 0px;
                  text-align: center;
                  color: #0772BA;
              }

              .footer-style {
                margin: 18px 12px 20px 12px;
              }

              .footer-content {
                flex-direction:row; 
                display:flex;flex:1; 
                justify-content: space-between;
                padding: 0px 138px 0px 0px;
              }
              
              .text-footer {
               font-size: 8px;
              }
          </style>
      </head>

      <body style='word-wrap:break-word'>
        <div class=WordSection1>
            <div class="div-border">
              <div class="div-title">
                <div class="title" style="margin-left: -40px">
                    <div class="left-title font-text" style="font-weight: 300;">${branchName}<br><br></div>
                    <div class="left-title font-text" style="text-align: center;">SỐ BÚT TOÁN: ${transRef}<br></div>
                    <div class="left-title font-text" style="text-align: center;">NGÀY GIAO DỊCH: ${transferDate}</div>
                  </div>
                  <div class="title">
                    <img src=${images.logoPVCB_bg_white} style="width: 110px;height: 48px;float: right; margin-right: 40px; margin-top: 20px" />
                  </div>
              </div>
              <div style="display: inline;">
                  <div style="text-align: center; margin-top: 20px;">
                      <div class="center-title font-text">${title}</div>
                  </div>
                  <br>
              </div>
              <div style="display: inline;">
                  <div style="text-align: center">
                    <span class="bold-text font-text">Kính gửi:</span>
                    <span id="userName" class="font-text">Quý khách hàng ${userName}</span>
                  </div><br>
              </div>
              <div class="div-content" style="padding: 0px 12px 0px 12px;">
                  <span class="content-text font-text">${textNote}</span>
              </div>
              <ul>
              <li class="div-content">
                  <span class="content-text font-text">Số tài khoản chuyển tiền: ${debitInfo.accountNo}</span><br>
                  <span class="content-text font-text">Đơn vị/Người chuyển tiền: ${debitInfo.accountName}</span><br>
                  <span id="debitBank" class="content-tex font-text">Tại ngân hàng: ${debitInfo.bankName}</span><br>
                  </li>
              <li class="div-content">
                  <span class="content-text font-text">Số tài khoản nhận: ${creditInfo.accountNo}</span><br>
                  <span class="content-text font-text">Đơn vị/Người nhận tiền: ${creditInfo.accountName}</span><br>
                  <span id="creditBank" class="content-text font-text">Tại ngân hàng: ${creditInfo.bankName}</span><br>
              </li>
              <li class="div-content">
              <span class="content-text font-text">Số tiền bằng số: ${transferInfo.transAmount}</span><br>
                  <span class="content-text font-text">Số tiền bằng chữ: ${transferInfo.formatAmount}</span><br>
              </li>
              <li class="div-content">
              <span class="content-text font-text">Diễn giải: ${transferInfo.content}</span><br>
              </li>
              </ul>
              <div style="margin-left: 12px">
                <span class="font-text" style="text-align: left;">Trân trọng cảm ơn.</span><br>
              </div>
              <div style="position: absolute; width: 160px;height: 160px;right: 0px; top: 300px; z-index: -1;">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 105.74 141.01"><defs><style>.cls-1,.cls-2,.cls-4{fill:none;}.cls-11,.cls-14,.cls-16,.cls-2,.cls-4{stroke:#ffc916;}.cls-11,.cls-16,.cls-2,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-16,.cls-2{stroke-width:1.04px;}.cls-3{fill:#ffc916;}.cls-14,.cls-4{stroke-width:1.05px;}.cls-5{opacity:0.6;}.cls-6{clip-path:url(#clip-path);}.cls-11,.cls-14,.cls-16,.cls-7{opacity:0.1;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:url(#linear-gradient);}.cls-10{clip-path:url(#clip-path-3);}.cls-11{fill:url(#linear-gradient-2);}.cls-12{clip-path:url(#clip-path-4);}.cls-13{clip-path:url(#clip-path-5);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{clip-path:url(#clip-path-6);}.cls-16{fill:url(#linear-gradient-4);}</style><clipPath id="clip-path"><rect class="cls-1" width="105.74" height="141.01"/></clipPath><clipPath id="clip-path-2"><path class="cls-1" d="M114.18,119.09c25.67-2.61,45.9-8.93,54.22-16.9,5.11-5.76-6.94-12.46-14.74-15.31-13-4.79-26-7-39.52-8.37Z"/></clipPath><linearGradient id="linear-gradient" x1="-1228.9" y1="214.16" x2="-1226.93" y2="214.16" gradientTransform="matrix(0, -20.46, -20.46, 0, 4524.58, -25027.92)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f9d804"/><stop offset="0.1" stop-color="#f9d804"/><stop offset="0.31" stop-color="#f6c20c"/><stop offset="0.74" stop-color="#f0891f"/><stop offset="0.8" stop-color="#ef8022"/><stop offset="1" stop-color="#ef8022"/></linearGradient><clipPath id="clip-path-3"><path class="cls-2" d="M88.09,120.39c-35.26,0-65.47-6.65-78.12-16.17a.12.12,0,0,0-.19,0,.24.24,0,0,0,.05.14L88.18,182.6,168.53,102c-10.84,10.59-42.73,18.31-80.44,18.35"/></clipPath><linearGradient id="linear-gradient-2" x1="-1196.46" y1="230.62" x2="-1194.49" y2="230.62" gradientTransform="matrix(80.61, 0, 0, -80.61, 96459.14, 18733.55)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f9d804"/><stop offset="0.04" stop-color="#f9d804"/><stop offset="0.52" stop-color="#f29b19"/><stop offset="0.77" stop-color="#ef8022"/><stop offset="1" stop-color="#ef8022"/></linearGradient><clipPath id="clip-path-4"><path class="cls-3" d="M88.18,181.54,10,104.22a.12.12,0,0,0-.19,0,.24.24,0,0,0,.05.14L88.18,182.6,168.53,102Z"/></clipPath><clipPath id="clip-path-5"><path class="cls-4" d="M61.78,69.25c-25.67,2.6-45.89,8.92-54.22,16.89-5.1,5.76,7,12.46,14.74,15.31,13,4.79,26,7,39.52,8.38Z"/></clipPath><linearGradient id="linear-gradient-3" x1="-1197.09" y1="292.96" x2="-1195.13" y2="292.96" gradientTransform="matrix(0, 20.46, 20.46, 0, -5960.5, 24565.67)" xlink:href="#linear-gradient"/><clipPath id="clip-path-6"><path class="cls-2" d="M87.87,68c35.26,0,65.48,6.65,78.12,16.16.11.07.17,0,.19,0a.2.2,0,0,0,0-.15L87.79,5.73,7.44,86.29C18.28,75.71,50.17,68,87.87,68"/></clipPath><linearGradient id="linear-gradient-4" x1="-1217.81" y1="227.62" x2="-1215.84" y2="227.62" gradientTransform="matrix(-80.61, 0, 0, 80.61, -98004.4, -18302.7)" xlink:href="#linear-gradient-2"/></defs><g class="cls-5"><g class="cls-6"><g class="cls-7"><g class="cls-8"><rect class="cls-9" x="107.98" y="66.38" width="71.7" height="64.82" transform="translate(-30.13 85.15) rotate(-30)"/></g></g><g class="cls-10"><rect class="cls-11" x="9.77" y="102.04" width="158.76" height="80.56"/></g><path class="cls-2" d="M88.09,120.39c-35.26,0-65.47-6.65-78.12-16.17a.12.12,0,0,0-.19,0,.24.24,0,0,0,.05.14L88.18,182.6,168.53,102c-10.84,10.59-42.73,18.31-80.44,18.35"/><path class="cls-3" d="M88.18,181.54,10,104.22a.12.12,0,0,0-.19,0,.24.24,0,0,0,.05.14L88.18,182.6,168.53,102Z"/><g class="cls-12"><rect class="cls-3" x="9.77" y="102.04" width="158.76" height="80.56"/></g><g class="cls-13"><rect class="cls-14" x="-3.71" y="57.12" width="71.7" height="64.82" transform="translate(-40.46 28.07) rotate(-30)"/></g><path class="cls-4" d="M61.78,69.25c-25.67,2.6-45.89,8.92-54.22,16.89-5.1,5.76,7,12.46,14.74,15.31,13,4.79,26,7,39.52,8.38Z"/><g class="cls-15"><rect class="cls-16" x="7.44" y="5.73" width="158.76" height="80.56"/></g><path class="cls-2" d="M87.87,68c35.26,0,65.48,6.65,78.12,16.16.11.07.17,0,.19,0a.2.2,0,0,0,0-.15L87.79,5.73,7.44,86.29C18.28,75.71,50.17,68,87.87,68"/></g></g></svg>
              </div>
              <div class="footer-style">
                <hr class="solid" style="height:1px; border-width:0px; color:gray; background-color:gray; margin-right: 138px">
                <p class="font-text" style="font-size: 10px; margin-top: -2px">
                    Chứng từ này được in từ hệ thống Ngân hàng Điện tử của Ngân hàng PVcomBank
                </p>
                <div class="footer-content">
                    <div>
                        <p class="text-footer font-text" style="color: #0772BA">
                            Ngân hàng TMCP Đại Chúng Việt Nam
                        </p>
                        <p class="text-footer font-text" style="margin-top: -4px">
                            Vietnam Joint Stock Commercial Bank
                        </p>
                    </div>
                    <div>
                        <p class="text-footer font-text" style="color: #0772BA">
                            Hội sở: Số 22 Ngô Quyền, Hoàn Kiếm, Hà Nội
                        </p>
                        <p class="text-footer font-text" style="margin-top: -4px">
                            Head Office: No22, Ngo Quyen, Hoan Kiem, Ha Noi
                        </p>
                    </div>
                    <div>
                        <p class="text-footer font-text">
                            Hotline:&nbsp;&nbsp;<spam style="font-weight: 600">1900 5555 92</spam>
                        </p>
                        <p class="text-footer font-text" style="margin-top: -4px">
                            Website:&nbsp;&nbsp;PVcomBank.com.vn
                        </p>
                    </div>
                </div>
              </div>
        </div>  
      </body>
  </html>`;
  return htmlString;
};
